export default "__VITE_ASSET__BGTJEqB4__"